import React, { ChangeEvent, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AccountCreateContext } from '@components-member/TradingAccounts/AccountCreate/context';
import { KeyMapKeys } from '@locales/lokalise/keyMap';
import { reactRouterService } from '@utils/library/reactRouter.service';
import { QUERY_PARAMS, TRADING_ACCOUNT_FORM_TYPE } from 'global.enums';
import { AccountCreateToggleButtonType } from './constants';
import styles from './styles.module.scss';

export interface IAccountCreateToggleButtonsProps {
  selectedAccountType: TRADING_ACCOUNT_FORM_TYPE;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  availableToggleButtonTypes: Set<AccountCreateToggleButtonType>;
}

export const AccountCreateToggleButtons = ({
  selectedAccountType,
  onChange,
  availableToggleButtonTypes,
}: IAccountCreateToggleButtonsProps) => {
  const { i18n } = useTranslation();

  const { contestId } = useContext(AccountCreateContext);

  useEffect(() => {
    const accountTypeButtons = Array.from(availableToggleButtonTypes);

    if (accountTypeButtons.length > 0) {
      const selectedButton = accountTypeButtons.find((button) => button.type === selectedAccountType);

      const accountType = selectedButton ? selectedButton.type : accountTypeButtons[0].type;

      reactRouterService.addUrlQueryParams({ [QUERY_PARAMS.OPEN_ACCOUNT]: accountType });
    } else {
      reactRouterService.addUrlQueryParams({ [QUERY_PARAMS.OPEN_ACCOUNT]: TRADING_ACCOUNT_FORM_TYPE.SELF });
    }
  }, [availableToggleButtonTypes, selectedAccountType]);

  if (!availableToggleButtonTypes.size || contestId) {
    return;
  }

  return (
    <div className={styles.switchButtons}>
      {Array.from(availableToggleButtonTypes).map((button) => {
        return (
          <label key={button.type} className="form__radio">
            <input
              className="form__radio-input"
              type="radio"
              name={button.name}
              value={button.type}
              checked={selectedAccountType === button.type}
              onChange={onChange}
            />
            <span className="form__radio-label">{i18n.t(button.name as KeyMapKeys)}</span>
          </label>
        );
      })}
    </div>
  );
};
